import { TOGGLE_TORCH_NOT_AVAILABLE_SCREEN } from "./displayTorchNotAvailableScreenReducer"

export const toggleTorchNotAvailableScreen = (value) => ({
    type: TOGGLE_TORCH_NOT_AVAILABLE_SCREEN,
    payload: value
})